export default {
    async registerTaskAsync (taskName) {
        return null;
    },
    async unregisterTaskAsync (taskName) {
        return null;
    }
};

//# sourceMappingURL=BackgroundNotificationTasksModule.js.map
